/**
 * useAdminSettings -- admin settings audit (P41.2).
 *
 * Reads GET /v1/admin/settings. Admin-only; gate the surrounding UI
 * with useMe() so non-admins don't fire the call.
 */
import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { api } from "shared/api/client";
import type { SettingsAdminResponse } from "shared/api/types";

export function useAdminSettings(
  options: { enabled?: boolean } = {},
): UseQueryResult<SettingsAdminResponse> {
  return useQuery<SettingsAdminResponse>({
    queryKey: ["admin-settings"] as const,
    queryFn: () => api.get<SettingsAdminResponse>("/v1/admin/settings"),
    enabled: options.enabled ?? true,
  });
}
